import React from 'react';
import ReactDOM from 'react-dom';
import CheckoutNext from './CheckoutNext';

// Self-mount into the template's root. React/ReactDOM are loaded as globals
// (UMD externals) by the page template's enqueue, same as device-finder.
function mount() {
  const el = document.getElementById('checkout-next-root');
  if (!el) return;
  if (ReactDOM.createRoot) {
    ReactDOM.createRoot(el).render(<CheckoutNext />);
  } else {
    ReactDOM.render(<CheckoutNext />, el);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mount);
} else {
  mount();
}

export default CheckoutNext;
